import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b68a7d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section footer__section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Thanks for visiting."),
  /*#__PURE__*/_createElementVNode("p", { class: "footer__repo" }, [
    /*#__PURE__*/_createTextVNode(" Source code: "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://github.com/Joblyn/My-portfolio",
      target: "_blank",
      rel: "noopener noreferrer"
    }, " GitHub repository ")
  ])
], -1))
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_section_header = _resolveComponent("section-header")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(_component_section_header, null, {
      default: _withCtx(() => [
        _createTextVNode("Colophon")
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createElementVNode("figure", null, [
          _createElementVNode("img", {
            alt: "Logo of Joblyn",
            src: require(`@/assets/images/logo.svg`)
          }, null, 8, _hoisted_3)
        ])
      ])
    ])
  ]))
}